// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + {"3395": "BackButton","3885": "PolicyPage","547": "PoliticsTabs","5497": "PrivacyContent","7697": "CookieContent","9727": "Core_LoginLayout",}[chunkId] + "." + {"3395": "d509579d","3885": "84770bb0","547": "65d3efdf","5497": "2332b174","7697": "4c7d3f91","9727": "b30509f2",}[chunkId] + ".css"
}